import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Opacity } from "@faire/web--source/slate/Color";
import React, { useEffect } from "react";
import ReactModal from "react-modal";
import { setAppElement } from "react-modal";
import styled, { css } from "styled-components";
var reactModalInitialized = false;
/**
 * Calls ReactModal.setAppElement which is required before showing any ReactModal dialog.
 * This function can be safely called many times.
 * It should not be called until we actually try to show a modal, in order to defer loading
 * all the react-modal JS.
 */ var initializeReactModal = function() {
    // eslint-disable-next-line no-process-env
    if ("production" !== "test" && !reactModalInitialized) {
        setAppElement("#root");
        reactModalInitialized = true;
    }
};
var Container = styled.div.withConfig({
    componentId: "sc-933ff5fc-0"
})([
    "display:flex;align-items:center;background-color:",
    ";box-shadow:4px 0 10px ",
    ";width:100%;height:fit-content;"
], Core.surface.inverse, Core.surface.default + Opacity.O_20);
var ReactModalAdapter = function(props) {
    var className = props.className, children = props.children, modalProps = _object_without_properties(props, [
        "className",
        "children"
    ]);
    useEffect(function() {
        initializeReactModal();
    }, []);
    var contentClassName = "".concat(className, "__content");
    var overlayClassName = "".concat(className, "__overlay");
    return /*#__PURE__*/ _jsx(ReactModal, _object_spread_props(_object_spread({
        portalClassName: className,
        className: contentClassName,
        overlayClassName: overlayClassName,
        closeTimeoutMS: 500
    }, modalProps), {
        children: /*#__PURE__*/ _jsx(Container, {
            children: children
        })
    }));
};
export var WrappedModal = styled(ReactModalAdapter).withConfig({
    componentId: "sc-933ff5fc-1"
})([
    "",
    " &__content{position:fixed;bottom:",
    "px;width:100%;z-index:11;outline:none;transition-duration:0.3s;transition-timing-function:cubic-bezier(0.215,0.61,0.355,1);transition-property:transform;transform:translateY(100%);&.ReactModal__Content--after-open{transform:translateY(0);}&.ReactModal__Content--before-close{transform:translateY(100%);}}"
], function(props) {
    return props.showOverlay ? css([
        "&__overlay{position:fixed;top:0;width:100vw;height:100vh;z-index:11;background-color:rgba(0,0,0,0.5);}"
    ]) : "";
}, function(props) {
    return props.bottom ? props.bottom : 0;
});
